import { useEffect } from "react";
import { useInView } from "react-intersection-observer";

import { paginationLimit } from "@const/feed";

/**
 * Kind of a good decision and implementation (not really)
 * @param {Object} arguments
 * @param {number} arguments.limit
 * @param {number} arguments.offset
 * @param {Function} arguments.callback
 * @param {boolean} arguments.isLoading
 * @param {number} arguments.totalCount
 */
export const useOffsetInfiniteScroll = ({
  totalCount,
  isLoading,
  callback,
  offset = 0,
  limit = paginationLimit,
  root,
}) => {
  const { ref, inView } = useInView({ root: root || null });
  const trigger = <div className="w-100" style={{ height: "1px" }} ref={ref} />;

  useEffect(() => {
    if (inView && !isLoading && totalCount > offset) {
      callback({
        offset,
        limit,
      });
    }
  }, [inView, isLoading, totalCount, callback, limit, offset]);

  return {
    trigger,
  };
};
